import { z } from "@reflag/shared/utils/zod";

export const PaginationQueryBaseSchema = (
  {
    sortOrder = "asc",
    pageIndex = 0,
    pageSize = 20,
  }: {
    sortOrder?: "asc" | "desc";
    pageIndex?: number;
    pageSize?: number;
  } = {
    sortOrder: "asc",
    pageIndex: 0,
    pageSize: 20,
  },
) =>
  z.object({
    sortOrder: z
      .enum(["asc", "desc"])
      .optional()
      .default(sortOrder)
      .describe("Sort direction (ascending or descending)"),
    pageIndex: z.coerce
      .number<number>()
      .int()
      .nonnegative()
      .optional()
      .default(pageIndex)
      .describe("Zero-based page index"),
    pageSize: z.coerce
      .number<number>()
      .int()
      .nonnegative()
      .min(0)
      .max(100)
      .optional()
      .default(pageSize)
      .describe("Number of items per page (1-100)"),
  });
